import Typography from '@/common/components/base/typography/Typography';
import { forwardRef } from 'react';
import { Box, Flex } from 'styled-system/jsx';
import RialAmount from '../cashComponent/RialAmount';
import WalletDetailLink from './WalletDetailLink';
import WalletWrapperCard from './WalletWrapperCard';

type ProjectCardProps = {
  amount: number;
  referenceId: string | null;
  fileCreatedAt: string | null;
  // row is hidden when the caller does not have this field at all
  sentToInsurerAt?: string | null;
};

export default forwardRef(function ProjectCard(
  { amount, referenceId, fileCreatedAt, sentToInsurerAt }: ProjectCardProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const rows = [
    {
      label: 'شناسه پرونده',
      value: referenceId?.split('_').reverse().join('_'),
    },
    { label: 'تاریخ ایجاد پرونده', value: fileCreatedAt },
    ...(sentToInsurerAt !== undefined
      ? [{ label: 'تاریخ ارسال به بیمه‌گر', value: sentToInsurerAt }]
      : []),
  ];

  return (
    <Box ref={ref}>
      <WalletWrapperCard
        wrapperProps={{
          width: '100%',
          padding: '12px',
          bgColor: 'white',
          border: '1px solid {colors.gray-3}',
        }}
      >
        <Flex flexDirection={'column'} gap={16}>
          <Flex
            height={32}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <RialAmount amount={amount} />
            <WalletDetailLink text="جزئیات" />
          </Flex>
          <Flex flexDirection={'column'} gap={8}>
            {rows.map((row) => (
              <Flex key={row.label} justifyContent={'space-between'}>
                <Typography fontSize={12} color={'black-2'}>
                  {row.label}
                </Typography>
                <Typography color={'black'}>{row.value || '-'}</Typography>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </WalletWrapperCard>
    </Box>
  );
});
